import { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import ProjectCard from './ProjectCard';
import ExperienceTimeline from './ExperienceTimeline';
import projectsData from '../data/projects.json';
import experiencesData from '../data/timeline.json';
import { Project, Experience } from '../types';

function Home() {
  const [projects, setProjects] = useState<Project[]>([]);
  const [experiences, setExperiences] = useState<Experience[]>([]);

  useEffect(() => {
    // Load projects and experiences
    setProjects(projectsData);
    setExperiences(experiencesData);

    // Check Supabase auth state - but don't fail if it doesn't work
    try {
      supabase.auth.getUser();
      supabase.auth.onAuthStateChange(() => {});
    } catch (error) {
      console.warn('Supabase auth not available:', error);
    }

    // Call backend
    const fetchBackend = async () => {
      const apiUrl = `${process.env.REACT_APP_API_URL}/hello`;
      console.log('Attempting to fetch from:', apiUrl);
      
      try {
        const res = await fetch(apiUrl, {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          mode: 'cors',
          credentials: 'include'
        });
        
        console.log('Response status:', res.status);
        console.log('Response headers:', Object.fromEntries(res.headers.entries()));
        
        if (!res.ok) {
          console.error(`Backend error: ${res.status} ${res.statusText}`);
          return;
        }

        const data = await res.json();
        console.log('Response data:', data);
      } catch (err) {
        console.error('⚠️ Could not connect to backend:', err);
      }
    };

    fetchBackend();
  }, []);

  return (
    <div className="App">
      <div className="about-me">
        <img src="/images/profile-photo.jpg" alt="Profile" className="profile-photo"/>
        <h1>About me</h1>
        <p>
          Currently making robots do useful things at Bear Robotics.
          I did my PhD at
          the <a href="https://rpl-as-ucl.github.io/">Robot Perception and Learning Lab</a> 
          and the <a href="https://www.ucl.ac.uk/ai-centre/">CDT for Foundational AI</a>,  
          <a href="https://www.ucl.ac.uk/">UCL</a>, 
          where I worked on bridging the gap between robotics 
          and intelligence through machine learning. 
          My recent interests include
          semantic correspondences, 
          world models, neural radiance fields, and imitation learning with diffusion.
        </p>
        <p>
          <a href="https://www.linkedin.com/in/denishadjivelichkov/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <a href="mailto:dennis.hvel@gmail.com" target="_blank" rel="noopener noreferrer">Email</a>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <a href="https://scholar.google.com/citations?hl=en&user=pFSbKWMAAAAJ" target="_blank" rel="noopener noreferrer">Scholar</a>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <a href="CV.pdf" target="_blank" rel="noopener noreferrer">CV</a>
        </p>
      </div>

      <h1>Projects & Publications</h1>
      <h4>
        Full list of publications available on
        &nbsp;<a href="https://scholar.google.com/citations?hl=en&user=pFSbKWMAAAAJ" target="_blank" rel="noopener noreferrer">Google Scholar</a>
      </h4>
      <div className="Projects-container">
        {projects.map((project) => (
          <ProjectCard key={project.id} project={project} />
        ))}
      </div>

      <h1>Roles & Experience</h1>
      <h4>
        More detailed CV available
        &nbsp;<a href="CV.pdf" target="_blank" rel="noopener noreferrer">here</a>
      </h4>
      <ExperienceTimeline experiences={experiences} />

      <div className="attribution">
        <h6>Website template made by &nbsp;
          <a href="https://github.com/dennisushi/dennisushi.github.io">Dennis Hadjivelichkov</a>
        </h6>
      </div>
    </div>
  );
}

export default Home; 